const t = "_wrapper_nggl9_1", n = "_icon_nggl9_10", e = "_title_nggl9_32", _ = {
  wrapper: t,
  icon: n,
  title: e
};
export {
  _ as default,
  n as icon,
  e as title,
  t as wrapper
};
